






















































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ShortTermDay, ApiError, ShortTermRate } from '@/api';
import { snackModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import CurrencyField from '@/components/CurrencyField.vue';

@Component({
  components: {
    ConfirmDialog,
    CurrencyField,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  rate: ShortTermDay | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];
  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThan(0)
        .test(Number(v)) || 'Must be a number greater than 0',
  ];

  get rateId() {
    return this.$route.params.rateId;
  }

  orderRates() {
    if (!this.rate || !this.rate.shortTermRates) {
      return;
    }

    this.rate.shortTermRates.sort((a, b) => {
      if (a.lot.name > b.lot.name) {
        return 1;
      }
      if (a.lot.name < b.lot.name) {
        return -1;
      }
      return 0;
    });
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.rate && this.rate.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.rate) {
      return;
    }

    if (this.rate.shortTermRates) {
      this.rate.shortTermRates.forEach(async rate => {
        try {
          await rate.save();
        } catch (err) {
          // Error
        }
      });
    }

    try {
      await this.rate.save();
      if (this.$route.name === 'admin-rates-add' && this.rate && this.rate.id) {
        this.$router.push({
          name: 'admin-rates-edit',
          params: { rateId: this.rate.id },
        });

        this.rate = (
          await ShortTermDay.includes(['shortTermRates.lot']).find(this.rateId)
        ).data;
        this.orderRates();
        snackModule.showSnackbar('Rate Created');
      } else {
        snackModule.showSnackbar('Rate Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-rates-edit' && this.rateId) {
      try {
        this.rate = (
          await ShortTermDay.includes(['shortTermRates.lot']).find(this.rateId)
        ).data;
        this.orderRates();
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Short term day not found');
      }
    } else {
      this.rate = new ShortTermDay();
    }
  }
}
